const checkForErrorsInID = (checkId?: string) => {
  return !!(checkId && (checkId.includes(' ') || checkId.includes('\n')));
};

export default checkForErrorsInID;
